/* eslint-disable */
import { DefaultRoute, ChangePasswordRoute } from '../router/routes'

export function getMHAmbiente() {
  // '00' = pruebas, '01' = producción. Por defecto '00': un entorno mal
  // configurado no debe poder emitir documentos como si fueran de producción.
  return process.env.REACT_APP_MH_AMBIENTE === '01' ? '01' : '00'
}

// CAT-011 "Tipo de item". El select de "Tipo de venta" solo puede ofrecer
// 1 (Bienes) y 2 (Servicios):
//   - Normativa v2.0, Anexo IV pag. 105, regla #34: "No aplican codigos 3 y 4".
//   - El codigo 4 ("Otros tributos por item") ademas arrastra una cascada de
//     reglas que la app no implementa: codTributo pasa a requerido, uniMedida
//     debe ser 99, y tributos debe incluir el 20 si hay ventas gravadas.
// Los schemas NO protegen esto: tipoItem esta declarado como integer pelado,
// sin enum ni rango, en los seis schemas oficiales.
//
// Se filtra solo en los selects. El catalogo COMPLETO se conserva en el store
// porque `resolverCatalogo` lo necesita para leer documentos ya emitidos que
// pudieran traer un 3 o un 4: filtrarlo en origen los dejaria sin resolver.
export const TIPO_ITEM_PERMITIDO = ['1', '2']

export const filtrarTiposDeVenta = (saleTypes) =>
  (saleTypes || []).filter((tipo) =>
    TIPO_ITEM_PERMITIDO.includes(String(tipo?.value))
  )

export function getAPIEndpointURL() {
  // El ambiente lo decide la configuracion, no el codigo.
  //
  // Estuvo clavado a la URL de QA desde el 2025-11-17. Como el frontal de
  // PRODUCCION se construye desde esta rama, el portal de produccion creaba
  // clientes y emitia documentos contra QA. El 02/09/2026 un usuario reporto
  // "no puedo registrar un cliente para facturarle": era esto.
  //
  // El valor por defecto es el de produccion a proposito: si algun dia se
  // despliega sin configurar, que falle hacia el lado seguro y no escriba en QA.
  return process.env.REACT_APP_API_SERVICE_URL || 'https://firma.rubridoc.com'
}
export function getDefaultLoginCredentials() {
  // El usuario de servicio tampoco es el mismo en cada ambiente: en isdb_prod
  // se llama 'crediq_usr_api' y en isdb_qa, 'rubridoc'. Pedir el de QA contra
  // produccion devuelve 500 "No users were found with the username".
  //
  // Sigue viajando dentro del bundle, asi que se lee con F12 igual que antes:
  // esto arregla el ambiente, no la exposicion. Eso pide un token de servicio
  // pedido por el backend, no credenciales en el navegador.
  return {
    userName: process.env.REACT_APP_API_SERVICE_USER || 'crediq_usr_api',
    password: process.env.REACT_APP_API_SERVICE_PASS || 'AAxLFyFD95@%WwV3PFiMFWgE$nL3JMWrK!@',
  }
}

export function getDefaultUserCredentials() {
  // companyId tiene que coincidir con el username real que usa el login por
  // defecto (getDefaultLoginCredentials, 'crediq_usr_api' en produccion):
  // cuando el login cae en la rama "else" de login.jsx (cualquier empresa sin
  // Company especifico, incluida CrediQ), el backend autentica contra ese
  // username y lo devuelve tal cual en la respuesta (TokenService.createToken
  // pone "username": authentication.getName()). VerticalLayout.js usa ese
  // valor como companyId para buscar al usuario aqui mismo
  // (users.find(user => user.companyId === userLogin.companyId)); si no
  // coincide, user queda undefined y getTemporalToken(undefined) manda el
  // login con el body vacio ("NONE_PROVIDED"). Se habia puesto 'rubridoc' fijo
  // (commit 813490f, revirtiendo sin querer el hotfix 312f17a) y ya no
  // coincidia con nada real. Se reutiliza getDefaultLoginCredentials() en vez
  // de repetir el valor para que nunca se vuelvan a desincronizar.
  const { userName, password } = getDefaultLoginCredentials()

  return {
    id: 1,
    companyId: userName,
    userName,
    password,
    userId: 1,
  }
}

export function getDefaultUserInnocomCredentials() {
  // return {
  //   id: 6, // 8=dev, 6=prod
  //   companyId: 'innocom',
  //   userName: 'innocom',
  //   password: 'Innocom023',
  //   userId: 6, // 8=dev, 6=prod
  // }

  return {
    id: 8,
    companyId: 'innocom',
    userName: 'innocom',
    password: 'Innocom023',
    userId: 8,
  }
}

export function checkIsCrediQ(value) {
  return [
    'crediq_usr_api',
    'quality_assurance_usr_api',
    'qa',
    'rubridoc',
  ].includes(value)
}

export function getInternalLogHeader(value) {
  const isCrediQ = checkIsCrediQ(value)
  const headers = {}

  if (isCrediQ) {
    headers['X-Request-Origin'] = 'INTERNAL_PORTAL'
  }

  return headers
}

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: 'short', day: 'numeric', year: 'numeric' }
) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(
    new Date(value)
  )
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (
  value,
  toTimeForCurrentDay = true
) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(
    new Date(value)
  )
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () =>
  JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (JSON.parse(localStorage.getItem('isTemporaryPassword'))) {
    return ChangePasswordRoute
  } else if (
    userRole &&
    !JSON.parse(localStorage.getItem('isTemporaryPassword'))
  ) {
    // console.log("from login", userRole, localStorage.getItem("isTemporaryPassword"))
    return DefaultRoute
  }
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed', // for input hover border-color
  },
})

export const permissions = [
  'geolocation',
  'notifications',
  'push',
  'midi',
  'microphone',
  'speaker',
  'device-info',
  'background-fetch',
  'background-sync',
  'bluetooth',
  'persistent-storage',
  'ambient-light-sensor',
  'accelerometer',
  'gyroscope',
  'magnetometer',
  'clipboard-read',
  'clipboard-write',
  'payment-handler',
]

export const checkPermissions = async (permissionName = 'camera') => {
  try {
    const permission = await navigator.permissions.query({
      name: permissionName,
    })
    return permission.state === 'granted'
  } catch (error) {
    return false
  }
}

export const promisifiedOldGUM = function (
  constraints,
  successCallback,
  errorCallback
) {
  // First get ahold of getUserMedia, if present
  const getUserMedia =
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia

  // Some browsers just don't implement it - return a rejected promise with an error
  // to keep a consistent interface
  if (!getUserMedia) {
    return Promise.reject(
      new Error('No existe el método getUserMedia en el navegador')
    )
  }

  // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
  return new Promise(function (successCallback, errorCallback) {
    getUserMedia.call(
      navigator,
      constraints,
      successCallback,
      errorCallback
    )
  })
}

/* Utils Facturador manual */

export const generateReceptorJson = (formData) => {
  switch (formData?.dteType?.value) {
    case '01': // Factura
      return {
        tipoDocumento: '02',
        numDocumento: formData.dui.replace(/[_-]/g, '') || '',
        nombre: formData.receiverName || '',
        codActividad: '10005', //formData.EconomicActivity?.value || '',
        descActividad: 'OTROS', //formData.EconomicActivity?.label || '',
        direccion: {
          departamento: formData?.department?.value || null,
          municipio: formData?.municipality?.value || null,
          distrito: formData?.district?.value || null,
          complemento: formData?.address || null,
        },
        telefono: formData.receiverPhoneNumber,
        correo: formData.receiverEmail,
      }
    case '03': // Crédito Fiscal
      return {
        nit: formData.nit.replace(/[_-]/g, '') || '',
        nrc: formData.nrc.replace(/[_-]/g, '') || '',
        nombre: formData.receiverName || '',
        nombreComercial: formData.tradeName || formData.receiverName || '',
        codActividad: formData?.economicActivity?.value,
        descActividad: formData?.economicActivity?.label || '',
        direccion: {
          departamento: formData?.department?.value,
          municipio: formData?.municipality?.value || null,
          distrito: formData?.district?.value || null,
          complemento: formData?.address || null,
        },
        telefono: formData.receiverPhoneNumber,
        correo: formData.receiverEmail,
      }
    case '05': // Nota Crédito
    case '06': // Nota Débito
      // MH v4 (NCE/NDE) sustituye "nit" por "tipoDocumento" + "numDocumento"
      return {
        tipoDocumento: '36',
        numDocumento: formData.nit.replace(/[_-]/g, '') || '',
        nrc: formData.nrc.replace(/[_-]/g, '') || '',
        nombre: formData.receiverName || '',
        nombreComercial: formData.tradeName || formData.receiverName || '',
        codActividad: formData?.economicActivity?.value,
        descActividad: formData?.economicActivity?.label || '',
        direccion: {
          departamento: formData?.department?.value,
          municipio: formData?.municipality?.value || null,
          distrito: formData?.district?.value || null,
          complemento: formData?.address || null,
        },
        telefono: formData.receiverPhoneNumber,
        correo: formData.receiverEmail,
      }

    case '11': // Facturas de exportación
      return {
        tipoDocumento: '37',
        numDocumento: formData.nit.replace(/[_-]/g, ''),
        nombre: formData.receiverName || '',
        nombreComercial: formData.tradeName || '',
        descActividad: formData.economicActivity?.label || '',
        codPais: formData.country?.value,
        nombrePais: formData.country?.label,
        complemento: formData.address || null,
        tipoPersona: 2,
        telefono: formData.receiverPhoneNumber || '+573113908205',
        correo: formData.receiverEmail,
      }

    case '14':
      // CAT-022: el sujeto excluido se identifica con DUI (13) o NIT (36),
      // según lo que elija el usuario en "Tipo de documento del cliente" —
      // antes se mandaba siempre "Otro" (37) sin importar cuál era
      return {
        tipoDocumento: formData.dteClientType?.value === 'nit' ? '36' : '13',
        numDocumento: formData.nit.replace(/[_-]/g, ''),
        nombre: formData.receiverName || '',
        codActividad: null, //formData?.economicActivity?.value,
        descActividad: null, //formData.economicActivity?.label || '',
        direccion: {
          departamento: formData?.department?.value,
          municipio: formData?.municipality?.value || null,
          distrito: formData?.district?.value || null,
          complemento: formData?.address || ' ',
        },
        telefono: formData.receiverPhoneNumber || '',
        correo: formData.receiverEmail,
      }
  }
}

export const generateDocumentBodyJson = (
  formData,
  dteType,
  relatedDoc,
  // { aplicaIvaRete, aplicaIvaPerci }: se derivan de los totales de la
  // factura para que la nota reproduzca la retención/percepción del CCFE
  taxOptions = {}
) => {
  // Rebaja unitaria en dinero, a partir del porcentaje capturado
  const discount = Number(
    ((formData.price * formData.discount) / 100).toFixed(2)
  )

  // Normativa #87, #89 y #92: el precio unitario es EL DEL PRODUCTO y la rebaja
  // viaja en su propio campo, que es requerido para la transmisión:
  //   #87 precioUni    "el precio unitario de cada producto o servicio"
  //   #89 montoDescu   "los descuentos, bonificaciones o rebajas realizadas al
  //                     precio"; $0.00 cuando no aplique
  //   #92 ventaGravada "[('Precio' * 'Cantidad') - 'Descuento por ítem']"
  //
  // Antes se restaba la rebaja del precio y `montoDescu` iba fijo en 0, con lo
  // que todo DTE con descuento declaraba que no lo hubo. El importe final NO
  // cambia —es la misma resta, reordenada—, así que ningún documento que hoy
  // se acepta pasa a rechazarse: solo se declara bien la descomposición.
  //
  // El descuento es de la LÍNEA completa, no de una unidad: la fórmula del #92
  // lo resta DESPUÉS de multiplicar por la cantidad.
  const cantidad = Number(formData.quantity) || 0
  const precioUni = Number(Number(formData.price).toFixed(2))
  const montoDescu = Number((discount * cantidad).toFixed(2))
  const ventaGravadaItem = Number(
    ((precioUni * cantidad) - montoDescu).toFixed(2)
  )

  // CAT-014 "Unidad de Medida": el catálogo usa códigos con cero a la
  // izquierda ('01' metro, '59' Unidad) y el DTE los transmite como número.
  // Antes iba fijo en 1, que es "metro", ignorando lo elegido en el formulario
  const uniMedida = Number(formData?.unitOfMeasure?.value) || 99

  // CAT-011 "Tipo de ítem" (#75). Antes iba fijo por rama de documento —1 en
  // FCF/FEXE/FSSE y 2 en CCF/NCE/NDE— ignorando el campo "Tipo de venta", que
  // es obligatorio en pantalla. Mismo defecto que tenía `uniMedida`.
  // El select ya viene filtrado a 1 y 2 (`filtrarTiposDeVenta`), porque la
  // regla #34 prohíbe los códigos 3 y 4. El `|| 2` es solo una red por si el
  // valor llegara vacío: 2 (Servicios) era el valor histórico de CCF/NCE/NDE,
  // que son la mayor parte del volumen.
  const tipoItem = Number(formData?.TypeOfSale?.value) || 2

  switch (dteType) {
    case '01': // Factura
      return {
        numItem: formData.id,
        tipoItem,
        numeroDocumento:
          // eslint-disable-next-line multiline-ternary
          dteType === '01' || dteType === '11'
            ? // eslint-disable-next-line multiline-ternary
              null
            : '79972E14-1AA2-4784-AADD-B294DE3220D8', // solicitar
        cantidad: formData.quantity,
        codigo: formData.productCode,
        uniMedida,
        descripcion: formData?.productName,
        precioUni,
        montoDescu,
        ventaNoSuj: 0,
        ventaExenta: 0,
        ventaGravada: ventaGravadaItem,
        codTributo: null,
        tributos: null,
        // En la FE los importes van CON IVA incluido, así que el IVA del ítem
        // se extrae de la venta gravada (x * 0.13 / 1.13), no se le suma
        ivaItem: parseFloat(
          ((ventaGravadaItem * 0.13) / 1.13).toFixed(2)
        ),
        noGravado: 0,
      }
    case '03': // Crédito Fiscal
      return {
        numItem: formData.id,
        tipoItem,
        cantidad: Number(formData.quantity),
        codigo: formData.productCode,
        uniMedida,
        descripcion: formData?.productName,
        precioUni,
        montoDescu,
        ventaNoSuj: 0,
        ventaExenta: 0,
        ventaGravada: ventaGravadaItem,
        codTributo: null,
        tributos: ['20'],
        psv: 0, // Crédito Fiscal
        noGravado: 0, // Crédito Fiscal
        numeroDocumento: null, // Crédito Fiscal
      }

    case '05': // Nota Crédito
    case '06': { // Nota Débito
      // MH v4: los ajustes de IVA viajan por ítem (#98-#101).
      // `ventaGravadaItem` se calcula arriba, común a los 5 tipos
      // 1% sobre las ventas gravadas del ítem, cuando el CCFE que
      // se ajusta llevaba percepción / retención. Si no, $0.00
      const unoPorCientoItem = Number((ventaGravadaItem * 0.01).toFixed(2))
      // La percepción (art. 163 CT) es "SOBRE EL PRECIO NETO DE VENTA DE LOS
      // BIENES TRANSFERIDOS": solo la llevan los ítems de bienes. La retención
      // (art. 162) sí alcanza a bienes Y servicios, así que no se filtra.
      // Misma asimetría que en `calcularTotales`
      const ivaPerci =
        taxOptions?.aplicaIvaPerci && tipoItem === 1 ? unoPorCientoItem : 0
      const ivaRete = taxOptions?.aplicaIvaRete ? unoPorCientoItem : 0
      // solo lleva IVA 13% cuando el documento ajustado es un CRE (07).
      // Ajustando un CCFE (03) el IVA viaja en resumen.tributos, y aquí va $0.00
      const ajustaCRE = relatedDoc?.tipoDte === '07'
      const ivaTreceItem = Number((ventaGravadaItem * 0.13).toFixed(2))
      const totalIva = ajustaCRE ? ivaTreceItem : 0

      return {
        numItem: formData.id,
        tipoItem,
        numeroDocumento: relatedDoc?.codigoGeneracion,
        cantidad: Number(formData.quantity),
        codigo: formData.productCode,
        uniMedida,
        descripcion: formData?.productName,
        precioUni,
        montoDescu,
        ventaNoSuj: 0,
        ventaExenta: 0,
        ventaGravada: ventaGravadaItem,
        noGravado: 0,
        ivaPerci,
        totalIva,
        ivaRete,
        codTributo: null,
        tributos: ['20'],
      }
    }

    case '11': // Facturas de exportación
      return {
        numItem: formData.id,
        tipoItem,
        numeroDocumento: null,
        cantidad: formData.quantity,
        codigo: formData.productCode,
        uniMedida,
        descripcion: formData?.productName,
        precioUni,
        montoDescu,
        ventaGravada: ventaGravadaItem,
        codTributo: null,
        tributos: ['C3'],
        noGravado: 0,
      }

    case '14': // Sujeto excluido
      return {
        numItem: formData.id,
        cantidad: formData.quantity,
        tipoItem,
        codigo: formData.productCode,
        uniMedida,
        descripcion: formData?.productName,
        precioUni,
        montoDescu,
        // #93: para FSSE la venta gravada se llama "compra"
        compra: ventaGravadaItem,
      }
  }
}

export const generateIdentificationyJson = (dteType) => {
  const today = new Date()

  // Obtener la fecha en formato "YYYY-MM-DD"
  const fecEmi = today.toLocaleDateString('en-CA', {
    timeZone: 'America/El_Salvador',
  })

  // Obtener la hora en formato "HH:MM:SS"
  const horEmi = today.toTimeString().split(' ')[0]
  const ambiente = getMHAmbiente()

  switch (dteType) {
    case '01': // Factura
      return {
        version: 2,
        ambiente,
        tipoDte: '01',
        tipoModelo: 1,
        tipoOperacion: 1,
        fecEmi,
        horEmi,
        tipoMoneda: 'USD',
      }
    case '03': // Crédito Fiscal
      return {
        version: 4,
        ambiente,
        tipoDte: '03',
        tipoModelo: 1,
        tipoOperacion: 1,
        fecEmi,
        horEmi,
        tipoMoneda: 'USD',
        numeroControl: 'DTE-03-ABCD5678-000000000000588',
        codigoGeneracion: '329A2AAA-0B96-4E85-ACE5-76B41C823CC5',
        tipoContingencia: null,
        motivoContin: null,
        //contrato: "0100000038389",
        //saldo: 13499.41
      }
    case '05': // Nota Crédito
    case '06': // Nota Débito
      return {
        version: 4,
        ambiente,
        tipoDte: dteType,
        tipoModelo: 1,
        tipoOperacion: 1,
        fecEmi,
        horEmi,
        tipoMoneda: 'USD',
        // #13 "Fusiones y otros": REQ/NULL en NCE y NDE
        fusion: null,
        //contrato: "123456"
      }

    case '11': // Facturas de exportación
      return {
        version: 3,
        ambiente,
        tipoDte: '11',
        tipoModelo: 1,
        tipoOperacion: 1,
        fecEmi,
        horEmi,
        tipoMoneda: 'USD',
        tipoContingencia: null,
        // #9: en v3 el campo pasa a llamarse "motivoContin"
        motivoContin: null,
      }

    case '14': // Sujeto Excluido
      return {
        version: 2,
        ambiente,
        tipoDte: '14',
        tipoModelo: 1,
        tipoOperacion: 1,
        fecEmi,
        horEmi,
        tipoMoneda: 'USD',
        numeroControl: '',
        codigoGeneracion: '',
        tipoContingencia: null,
        motivoContin: null,
        //contrato: "",
        //saldo: 13499.41
      }
  }
}

export const generateSummaryJson = (
  formData,
  dteType,
  relatedDoc,
  paymentCondition,
  // cuerpoDocumento ya armado: en NCE/NDE los totales del resumen son, por
  // norma, la suma de los ajustes por ítem
  documentBody = []
) => {
  const sumarItems = (campo) =>
    Number(
      (Array.isArray(documentBody) ? documentBody : [])
        .reduce((acc, item) => acc + (Number(item?.[campo]) || 0), 0)
        .toFixed(2)
    )

  // #135 "Total de descuentos": "la sumatoria de los descuentos aplicados por
  // cada ítem más los descuentos globales al total de operaciones por tipo de
  // ventas". Es informativo, pero requerido por tipo de operación.
  //
  // La app no tiene descuento global: el botón "Agregar descuento" reparte el
  // porcentaje ítem por ítem (`AdddiscountHandleChange`). Por eso los campos
  // de descuento global —descuNoSuj (#130), descuExenta (#131) y descuGravada
  // (#132)— se quedan en 0, y esto es solo la suma del cuerpo.
  const totalDescu = sumarItems('montoDescu')

  const condicionOperacion = paymentCondition?.condicionOperacion ?? 1
  const pagoPeriodo = paymentCondition?.periodo ?? null
  const pagoPlazo = paymentCondition?.plazo ?? null
  // Forma de pago seleccionada en el formulario (CAT-017). Si no se eligió,
  // cada DTE cae a su valor por defecto histórico
  const formaPago = paymentCondition?.formaPago ?? null

  switch (dteType) {
    case '01': // Factura
      return {
        resumen: {
          totalNoSuj: 0,
          totalExenta: 0,
          totalGravada: formData.total,
          subTotalVentas: formData.total,
          descuNoSuj: 0,
          descuExenta: 0,
          descuGravada: 0,
          porcentajeDescuento: 0,
          totalDescu,
          subTotal: formData.total,
          ivaRete: 0,
          montoTotalOperacion: formData.total,
          totalNoGravado: 0,
          totalPagar: formData.total,
          totalLetras: numToText(formData.total),
          totalIva:
            Math.round(((formData.total * 0.13) / 1.13) * 100) / 100,
          condicionOperacion,
          observaciones: '',
          pagos: [
            {
              codigo: formaPago ?? '01',
              montoPago: formData.total,
              referencia: 'reference',
              periodo: pagoPeriodo,
              plazo: pagoPlazo,
            },
          ],
          numPagoElectronico: null,
          tributos: null,
          saldoFavor: 0,
        },
        apendice: [
          {
            campo: 'sucursal',
            etiqueta: 'SUCURSAL',
            valor: 'SUC',
          },
          {
            campo: 'condicion_operacion',
            etiqueta: 'COND.OPERACION',
            valor: condicionOperacion === 2 ? 'CREDITO' : 'CONTADO',
          },
          {
            campo: 'vendedor',
            etiqueta: 'VENDEDOR',
            valor: 'KRGONZALEZ',
          },
          {
            campo: 'codigo_cxc',
            etiqueta: 'CODIGO VENDEDOR',
            valor: 'KRGONZALEZ',
          },
        ],
        documentoRelacionado: null,
        otrosDocumentos: null,
        ventaTercero: null,
      }
    case '03': { // Crédito Fiscal
      // IVA percibido y IVA retenido: calcularTotales ya los calcula,
      // deben viajar al resumen en lugar de ir fijos en 0
      const ivaPerci = Number((formData.IVAPercibido ?? 0).toFixed(2))
      const ivaRete = Number((formData.retencionRenta ?? 0).toFixed(2))
      // Monto total de la operación + IVA percibido - IVA retenido
      const totalPagar = Number(
        (formData.total + ivaPerci - ivaRete).toFixed(2)
      )

      return {
        resumen: {
          totalNoSuj: 0,
          totalExenta: 0,
          totalGravada: formData.subTotal,
          subTotalVentas: formData.subTotal,
          descuNoSuj: 0,
          descuExenta: 0,
          descuGravada: 0,
          porcentajeDescuento: 0,
          totalDescu,
          subTotal: formData.subTotal,
          ivaRete,
          montoTotalOperacion: formData.total,
          totalNoGravado: 0,
          totalPagar,
          totalLetras: numToText(totalPagar),
          condicionOperacion,
          observaciones: '',
          pagos: [
            {
              codigo: formaPago ?? '01',
              montoPago: formData.subTotal,
              referencia: 'techywe',
              periodo: pagoPeriodo,
              plazo: pagoPlazo,
            },
          ],
          numPagoElectronico: null,
          tributos: [
            {
              codigo: '20',
              descripcion: 'Impuesto al Valor Agregado 13%',
              valor: parseFloat((formData.subTotal * 0.13).toFixed(2)),
            },
          ],
          saldoFavor: 0,
          ivaPerci,
        },
        apendice: [
          {
            campo: 'sucursal',
            etiqueta: 'SUCURSAL',
            valor: 'SUC',
          },
          {
            campo: 'condicion_operacion',
            etiqueta: 'COND.OPERACION',
            valor: condicionOperacion === 2 ? 'CREDITO' : 'CONTADO',
          },
          {
            campo: 'vendedor',
            etiqueta: 'VENDEDOR',
            valor: 'KRGONZALEZ',
          },
          {
            campo: 'codigo_cxc',
            etiqueta: 'CODIGO VENDEDOR',
            valor: 'KRGONZALEZ',
          },
        ],
        documentoRelacionado: dteType === '06' ? [relatedDoc] : null,
        /*{
        "tipoDocumento": "03",
        "tipoGeneracion": 1,
        "numeroDocumento": "1234",
        "fechaEmision": "2023-11-29"
      }*/
        //otrosDocumentos: null, // no permitido en credito fiscal
        ventaTercero:
          // eslint-disable-next-line multiline-ternary
          dteType === '06'
            ? // eslint-disable-next-line multiline-ternary
              {
                nit: '04030512851011',
                nombre: 'Tercero XYZ',
              }
            : null,
      }
    }
    case '05': { // Nota Crédito
      // suma de los ajustes por ítem
      const ivaPerci = sumarItems('ivaPerci')
      const ivaRete = sumarItems('ivaRete')
      const totalIva = sumarItems('totalIva')
      const montoTotalOperacion = parseFloat(formData.total.toFixed(2))
      // Monto total de la operación + IVA percibido - IVA retenido
      const totalPagar = Number(
        (montoTotalOperacion + ivaPerci - ivaRete).toFixed(2)
      )

      return {
        resumen: {
          totalNoSuj: 0,
          totalExenta: 0,
          totalGravada: formData.subTotal,
          subTotalVentas: formData.subTotal,
          totalDescu,
          montoTotalOperacion,
          ivaPerci,
          // null cuando el documento ajustado es un CCFE
          codigoRetencionMH: null,
          totalIva,
          ivaRete,
          totalNoGravado: 0,
          totalPagar,
          totalLetras: numToText(totalPagar),
          condicionOperacion,
          observaciones: '',
          tributos: [
            {
              codigo: '20',
              descripcion: 'Impuesto al Valor Agregado 13%',
              valor: parseFloat((formData.subTotal * 0.13).toFixed(2)),
            },
          ],
        },
        apendice: [
          {
            campo: 'sucursal',
            etiqueta: 'SUCURSAL',
            valor: 'SUC',
          },
          {
            campo: 'condicion_operacion',
            etiqueta: 'COND.OPERACION',
            valor: condicionOperacion === 2 ? 'CREDITO' : 'CONTADO',
          },
          {
            campo: 'vendedor',
            etiqueta: 'VENDEDOR',
            valor: 'KRGONZALEZ',
          },
          {
            campo: 'codigo_cxc',
            etiqueta: 'CODIGO VENDEDOR',
            valor: 'KRGONZALEZ',
          },
        ],
        documentoRelacionado: [
          {
            tipoDocumento: relatedDoc.tipoDte,
            // CAT-007: el documento ajustado se selecciona de los DTE ya
            // transmitidos, por lo que siempre es electrónico (2). Con 1 (físico)
            // MH omite la verificación de existencia del código de generación
            tipoGeneracion: relatedDoc?.codigoGeneracion ? 2 : 1,
            fechaEmision: relatedDoc.fecEmi,
            numeroDocumento: relatedDoc.codigoGeneracion,
          },
        ],
        //otrosDocumentos: null, // no permitido en credito fiscal
        ventaTercero:
          // eslint-disable-next-line multiline-ternary
          dteType === '06'
            ? // eslint-disable-next-line multiline-ternary
              {
                nit: '04030512851011',
                nombre: 'Tercero XYZ',
              }
            : null,
      }
    }

    case '06': { // Nota Débito
      // suma de los ajustes por ítem
      const ivaPerci = sumarItems('ivaPerci')
      const ivaRete = sumarItems('ivaRete')
      const totalIva = sumarItems('totalIva')
      const montoTotalOperacion = parseFloat(formData.total.toFixed(2))
      // Monto total de la operación + IVA percibido - IVA retenido
      const totalPagar = Number(
        (montoTotalOperacion + ivaPerci - ivaRete).toFixed(2)
      )

      return {
        resumen: {
          totalNoSuj: 0,
          totalExenta: 0,
          totalGravada: formData.subTotal,
          subTotalVentas: formData.subTotal,
          totalDescu,
          montoTotalOperacion,
          ivaPerci,
          // null cuando el documento ajustado es un CCFE
          codigoRetencionMH: null,
          totalIva,
          ivaRete,
          totalNoGravado: 0,
          totalPagar,
          totalLetras: numToText(totalPagar),
          condicionOperacion,
          observaciones: '',
          // numPagoElectronico solo aplica a NDE, no a NCE
          numPagoElectronico: null,
          tributos: [
            {
              codigo: '20',
              descripcion: 'Impuesto al Valor Agregado 13%',
              valor: parseFloat((formData.subTotal * 0.13).toFixed(2)),
            },
          ],
        },
        apendice: [
          {
            campo: 'sucursal',
            etiqueta: 'SUCURSAL',
            valor: 'SUC',
          },
          {
            campo: 'condicion_operacion',
            etiqueta: 'COND.OPERACION',
            valor: condicionOperacion === 2 ? 'CREDITO' : 'CONTADO',
          },
          {
            campo: 'vendedor',
            etiqueta: 'VENDEDOR',
            valor: 'KRGONZALEZ',
          },
          {
            campo: 'codigo_cxc',
            etiqueta: 'CODIGO VENDEDOR',
            valor: 'KRGONZALEZ',
          },
        ],
        documentoRelacionado: [
          {
            tipoDocumento: relatedDoc.tipoDte,
            //  CAT-007: el documento ajustado se selecciona de los DTE ya
            // transmitidos, por lo que siempre es electrónico (2). Con 1 (físico)
            // MH omite la verificación de existencia del código de generación
            tipoGeneracion: relatedDoc?.codigoGeneracion ? 2 : 1,
            fechaEmision: relatedDoc.fecEmi,
            numeroDocumento: relatedDoc.codigoGeneracion,
          },
        ],
        ventaTercero: null,
      }
    }
    case '11': // Facturas de exportación
      return {
        resumen: {
          totalGravada: formData.total,
          // en v3 "descuento" pasa a llamarse "descuGravada"
          descuGravada: 0,
          porcentajeDescuento: 0,
          totalDescu,
          seguro: 0,
          flete: 0,
          tributos: [
            {
              codigo: 'C3',
              descripcion:
                'Impuesto al Valor Agregado (exportaciones) 0%',
              valor: 0,
            },
          ],
          montoTotalOperacion: formData.total,
          // exportaciones que no representan ventas
          totalNoOnerosas: 0,
          totalNoGravado: 0,
          totalPagar: formData.total,
          totalLetras: numToText(formData.total),
          condicionOperacion,
          pagos: [
            {
              codigo: formaPago ?? '05',
              montoPago: formData.total,
              referencia: 'RECIBO EXP :MAN-42',
              periodo: pagoPeriodo,
              plazo: pagoPlazo,
            },
          ],
          numPagoElectronico: null,
          observaciones: 'FACTURA EXPORTACION',
          codIncoterms: null,
          descIncoterms: null,
          // opcional en uso, pero el valor siempre viaja
          saldoFavor: 0,
        },
        apendice: [
          {
            campo: 'sucursal',
            etiqueta: 'SUCURSAL',
            valor: 'SUC',
          },
          {
            campo: 'condicion_operacion',
            etiqueta: 'COND.OPERACION',
            valor: condicionOperacion === 2 ? 'CREDITO' : 'CONTADO',
          },
          {
            campo: 'vendedor',
            etiqueta: 'VENDEDOR',
            valor: 'KRGONZALEZ',
          },
          {
            campo: 'codigo_cxc',
            etiqueta: 'CODIGO VENDEDOR',
            valor: 'KRGONZALEZ',
          },
        ],
        // Secciones nuevas en FEXE v3 (#14-#17 y Sección 7): null si no aplican
        documentoRelacionado: null,
        compraTercero: null,
        otrosDocumentos: null,
        ventaTercero: null,
      }
    case '14':
      return {
        resumen: {
          totalCompra: formData.total,
          // el FSEE usa un único descuento global al total de operaciones
          descu: 0,
          totalDescu,
          subTotal: formData.total,
          // el FSEE es el único de los seis que conserva reteRenta
          reteRenta: Number(formData.retencionRenta.toFixed(2)),
          totalPagar: Number(
            (formData.total - formData.retencionRenta).toFixed(2)
          ),
          totalLetras: numToText(
            Number((formData.total - formData.retencionRenta).toFixed(2))
          ),
          condicionOperacion,
          pagos: [
            {
              codigo: formaPago ?? '05',
              montoPago: Number(
                (formData.total - formData.retencionRenta).toFixed(2)
              ),
              referencia: 'reference',
              periodo: pagoPeriodo,
              plazo: pagoPlazo,
            },
          ],
          observaciones: 'FACTURA SE',
        },
        apendice: [
          {
            campo: 'sucursal',
            etiqueta: 'SUCURSAL',
            valor: 'SUC',
          },
        ],
      }
  }
}

export const generateExtensionJson = (receptor, emisor) => {
  switch (receptor?.dteType?.value) {
    case '01':
    case '03':
      return {
        nombEntrega: emisor.nombre,
        docuEntrega: emisor.nit.replace(/[_-]/g, ''),
        nombRecibe: receptor.receiverName,
        // eslint-disable-next-line multiline-ternary
        docuRecibe: receptor?.dui
          ? // eslint-disable-next-line multiline-ternary
            receptor?.dui.replace(/[_-]/g, '')
          : receptor?.nit.replace(/[_-]/g, ''),
        observaciones: '000101146795',
        placaVehiculo: 'SINPLACA',
      }
    case '05': // Nota Crédito
    case '06': // Nota Débito
      return {
        nombEntrega: emisor.nombre,
        docuEntrega: emisor.nit.replace(/[_-]/g, ''),
        nombRecibe: receptor.receiverName,
        // eslint-disable-next-line multiline-ternary
        docuRecibe: receptor?.dui
          ? // eslint-disable-next-line multiline-ternary
            receptor?.dui.replace(/[_-]/g, '')
          : receptor?.nit.replace(/[_-]/g, ''),
        observaciones: 'No hay observaciones adicionales',
      }
    case '11': // Factura de exportacion
      return {}
    // nombEntrega: "Nombre Entrega",
    // docuEntrega: "DOC123",
    // nombRecibe: "Nombre Recibe",
    // docuRecibe: "DOC456",
    // observaciones: "Observaciones adicionales"
  }
}

export const generateinvalidateJson = (
  emisor,
  receptor,
  observations,
  originalDoc
) => {
  const today = new Date()
  const fecAnula = today.toLocaleDateString('en-CA', {
    timeZone: 'America/El_Salvador',
  })
  const horAnula = today.toTimeString().split(' ')[0]

  /* Receptor del DTE que se invalida. El tipo de documento va en null a propósito: MH exige
     el mismo que declaró el DTE original y varía por emisor y por canal, así que Rubridoc lo
     completa leyéndolo del DTE. */
  const receiverDocument = receptor.taxCredit.dui
  const receiverName = receptor.taxCredit.receiverName

  const invalidateData = {
    identificacion: {
      version: 2,
      ambiente: getMHAmbiente(),
      fecAnula,
      horAnula,
    },
    emisor,
    documento: {
      tipoDte: receptor.emisionType,
      codigoGeneracion: receptor.taxCredit.value,
      selloRecibido: receptor.taxCredit.stampReceived,
      numeroControl: originalDoc.numeroControl,
      fecEmi: originalDoc.fecEmi,
      montoIva: originalDoc.montoIva,
      codigoGeneracionR: null, //receptor.taxCreditR.value,
      tipoDocumento: null,
      numDocumento: receiverDocument,
      nombre: receiverName,
      telefono: receptor.taxCredit.receiverPhoneNumber,
      correo: receptor.taxCredit.receiverEmail,
    },
    motivo: {
      tipoAnulacion: 2,
      motivoAnulacion: observations || 'No hay observaciones',
      nombreResponsable: emisor.nombreComercial,
      tipDocResponsable: '36',
      numDocResponsable: emisor.nit,
      /* Quien solicita el evento es el receptor del DTE. Con tipoAnulacion 2 o 3 el MH
         exige los tres campos con valor: iban en null y rechazaba con el error 096. */
      nombreSolicita: receiverName,
      tipDocSolicita: null,
      numDocSolicita: receiverDocument,
    },
  }

  return invalidateData
}

export function numToText(num) {
  const unidades = [
    'CERO',
    'UNO',
    'DOS',
    'TRES',
    'CUATRO',
    'CINCO',
    'SEIS',
    'SIETE',
    'OCHO',
    'NUEVE',
  ]
  const decenas = [
    'DIEZ',
    'ONCE',
    'DOCE',
    'TRECE',
    'CATORCE',
    'QUINCE',
    'DIECISEIS',
    'DIECISIETE',
    'DIECIOCHO',
    'DIECINUEVE',
  ]
  const decenasMayor = [
    '',
    '',
    'VEINTE',
    'TREINTA',
    'CUARENTA',
    'CINCUENTA',
    'SESENTA',
    'SETENTA',
    'OCHENTA',
    'NOVENTA',
  ]
  const centenas = [
    '',
    'CIENTO',
    'DOSCIENTOS',
    'TRESCIENTOS',
    'CUATROCIENTOS',
    'QUINIENTOS',
    'SEISCIENTOS',
    'SETECIENTOS',
    'OCHOCIENTOS',
    'NOVECIENTOS',
  ]

  function convertir(num) {
    if (num === 100) return 'CIEN'
    if (num < 10) return unidades[num]
    if (num < 20) return decenas[num - 10]
    if (num < 100) {
      return `${decenasMayor[Math.floor(num / 10)]}${
        num % 10 !== 0 ? ` Y ${unidades[num % 10]}` : ''
      }`
    }
    if (num < 1000) {
      return `${centenas[Math.floor(num / 100)]}${
        num % 100 !== 0 ? ` ${convertir(num % 100)}` : ''
      }`
    }
    if (num === 1000) return 'MIL'
    if (num < 2000) return `MIL ${convertir(num % 1000)}`
    if (num < 1000000) {
      if (num < 2000) return `MIL ${convertir(num % 1000)}`
      if (num < 1000000) {
        const miles = Math.floor(num / 1000)
        const resto = num % 1000
        return `${convertir(miles)} MIL${
          resto !== 0 ? ` ${convertir(resto)}` : ''
        }`
      }
    }
    return ''
  }

  function formatearMoneda(numero) {
    const entero = Math.floor(numero)
    const decimal = Math.round((numero - entero) * 100)

    const textoEntero = convertir(entero)
    const textoDecimal = decimal < 10 ? `0${decimal}` : decimal

    return `${textoEntero} CON ${textoDecimal} /100 USD DOLARES`.trim()
  }

  return formatearMoneda(num)
}

export function transformMHProductsToLocal(items) {
  return items.map((item) => ({
    id: item.numItem, // Correspondencia con numItem
    prodType: { value: 'Producto', label: 'Producto' }, // Valor fijo como ejemplo
    productCode: item.codigo, // Correspondencia con codigo
    productName: item.descripcion, // Correspondencia con descripcion
    quantity: item.cantidad, // Correspondencia con cantidad
    description: 'new', // Valor fijo
    unitOfMeasure: { value: 'Metro', label: 'Metro' }, // Valor fijo como ejemplo
    TypeOfSale: 'Servicios', // Valor fijo
    price: item.precioUni, // Correspondencia con precioUni
    discount: item.montoDescu, // Correspondencia con montoDescu
    accept: true, // Valor fijo
    isActive: true, // Valor fijo
  }))
}

export function formatDateToYMD(isoDateStr) {
  const date = new Date(isoDateStr)

  // Verificar si la fecha es válida
  if (isNaN(date.getTime())) {
    throw new Error('Fecha no válida')
  }

  // Convertir la fecha al formato "yyyy-MM-dd"
  return date.toISOString().split('T')[0]
}
